import { render, staticRenderFns } from "./EditClassificacao.vue?vue&type=template&id=3bf266a8"
import script from "./EditClassificacao.vue?vue&type=script&lang=js"
export * from "./EditClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports